var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4983 12.4994L10.8316 16.6661L7.49828 7.4994L16.6649 10.8327L12.4983 12.4994ZM12.4983 12.4994L16.6649 16.6661M5.98828 1.86523L6.63578 4.2794M4.27828 6.6369L1.86328 5.9894M11.6233 3.3744L9.85495 5.14273M5.14078 9.85607L3.37411 11.6244",
    stroke: "#0A0A0A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCursor);
export default __webpack_public_path__ + "static/media/BigCursor.f77f404926f28efce9d3e917b68e25c8.svg";
export { ForwardRef as ReactComponent };